import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/Login/Login";
import { Check, ExclamationCircle, InfoCircle, XCircle } from 'react-bootstrap-icons';
import Dashboard from "./pages/Dashboard/Dashboard";
import axios from "axios";
import { usersActions } from "./data/user";
import Sidebar from "./components/Sidebar.js/Sidebar";
import { Route, Switch } from 'react-router-dom';
import Header from "./common/Header/Header";
import Users from "./pages/Users/Users";
import Booking from "./pages/Booking/Booking";
import Vehicles from "./pages/Vehicles/Vehicles";
import Boats from "./pages/Boats/Boats";
import Containers from "./pages/Containers/Containers";
import Calculators from "./pages/Calculators/Calculators";
import Transactions from "./pages/Transactions/Transactions";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import CarDetailsPage from "./pages/CarDetailsPage/CarDetailsPage";
import Tickets from "./pages/Tickets/Tickets";
import News from "./pages/News/News";
import BalanceRequests from "./pages/BalanceRequests/BalanceRequests";
import Financing from "./pages/Financing/Financing";
import Earnings from "./pages/Earnings/Earnings";
import BankReconcile from "./pages/BankReconcile/BankReconcile";
import Broadcast from "./pages/Broadcast/Broadcast";
import Chat from "./pages/Chat/Chat";
import Surveys from "./pages/Surveys/Surveys";
import Messaging from "./pages/Messaging/Messaging";
import ActivityLog from "./pages/ActivityLog/ActivityLog";
import Permissions from "./pages/Permissions/Permissions";
import Reports from "./pages/Reports/Reports";
import CalculatorCategories from "./pages/CalculatorCategories/CalculatorCategories";
import CustomsCalculator from "./pages/CustomsCalculator/CustomsCalculator";
import Integrations from "./pages/Integrations/Integrations";
import Settings from "./pages/Settings/Settings";

function App() {
    const user = useSelector((state) => state.user);
    const notification = useSelector((state) => state.notification);
    const isLoggedIn = user.isLoggedIn;
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [minimized, setMinimized] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    // On phones/tablets the sidebar is an off-canvas drawer; on desktop the
    // toggle collapses it to an icon rail.
    const toggleSidebar = () => {
        if (typeof window !== "undefined" && window.innerWidth <= 992) setMobileOpen((o) => !o);
        else setMinimized((m) => !m);
    };

    // Global auth guard: if any request comes back 401 (session expired/invalid),
    // drop the logged-in state so the app shows the login screen instead of
    // silently failing requests.
    useEffect(() => {
        const interceptorId = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error && error.response && error.response.status === 401) {
                    dispatch(usersActions.changeIsLoggedIn(false));
                }
                return Promise.reject(error);
            }
        );
        return () => axios.interceptors.response.eject(interceptorId);
    }, [dispatch]);

    useEffect(() => {
        axios('/api/user')
            .then((res) => {
                setLoading(false);
                const data = res.data.data;
                dispatch(usersActions.changeIsLoggedIn(true));
                dispatch(usersActions.saveUserData(data));
            })
            .catch((err) => {
                setLoading(false);
            })
    }, [dispatch])
    
    return (
        <main className="main-wrapper">
            {notification.show && <div className={`notification-container ${notification.type}`}>
                <div className="notification-body">
                    {notification.type === "success-notification" && <Check style={{fontSize: "30px", color: "white", background: "green", borderRadius: "50%"}} />}
                    {notification.type === "error-notification" && <XCircle style={{fontSize: "30px", color: "red", background: "none", borderRadius: "50%"}} />}
                    {notification.type === "warning-notification" && <ExclamationCircle style={{fontSize: "30px", color: "orange", background: "none", borderRadius: "50%"}} />}
                    {notification.type === "info-notification" && <InfoCircle style={{fontSize: "30px", color: "blue", background: "none", borderRadius: "50%"}} />}
                    <p>{notification.text}</p>
                </div>
            </div>}
            {
                (!loading && !isLoggedIn) && <Login />
            }
            {
                (!loading && isLoggedIn) && <div className={`logged-in-user-container${minimized ? " sidebar-minimized" : ""}${mobileOpen ? " sidebar-mobile-open" : ""}`}>
                    {mobileOpen && <div className="sidebar-backdrop" onClick={() => setMobileOpen(false)}></div>}
                    <Sidebar minimized={minimized} onClose={() => setMobileOpen(false)} />
                    <div className="logged-in-user-content">
                        <Header minimized={minimized} minimizer={setMinimized} onToggle={toggleSidebar} />
                        <div className="content-scroll">
                            <Switch>
                                <Route exact path="/" ><Dashboard /></Route>
                                <Route exact path="/users" ><Users /></Route>
                                <Route exact path="/booking" ><Booking /></Route>
                                <Route exact path="/cars" ><Vehicles /></Route>
                                <Route exact path="/boats" ><Boats /></Route>
                                <Route exact path="/containers" ><Containers /></Route>
                                <Route exact path="/calculator" ><Calculators /></Route>
                                <Route exact path="/transactions" ><Transactions /></Route>
                                <Route exact path="/ticket" ><Tickets /></Route>
                                <Route exact path="/news" ><News /></Route>
                                <Route exact path="/balance-requests" ><BalanceRequests /></Route>
                                <Route exact path="/financing" ><Financing /></Route>
                                <Route exact path="/earnings" ><Earnings /></Route>
                                <Route exact path="/bank-reconcile" ><BankReconcile /></Route>
                                <Route exact path="/broadcast" ><Broadcast /></Route>
                                <Route exact path="/chat" ><Chat /></Route>
                                <Route exact path="/surveys" ><Surveys /></Route>
                                <Route exact path="/messaging" ><Messaging /></Route>
                                <Route exact path="/activity-log" ><ActivityLog /></Route>
                                <Route exact path="/permissions" ><Permissions /></Route>
                                <Route exact path="/reports" ><Reports /></Route>
                                <Route exact path="/calculator-categories" ><CalculatorCategories /></Route>
                                <Route exact path="/customs-calculator" ><CustomsCalculator /></Route>
                                <Route exact path="/integrations" ><Integrations /></Route>
                                <Route exact path="/settings" ><Settings /></Route>
                                <Route exact path="/change-password" ><ChangePassword /></Route>
                                <Route exact path="/vehicle-details/:id" ><CarDetailsPage /></Route>
                            </Switch>
                        </div>
                    </div>
                </div>
            }
        </main>
    );
}

export default App;
